/**
 * @file 门店列表
 * @author fuqiang15
 */

import ListModel from '@baidu/ve-ria/views/ListModel';
import {assign, pick, filter, includes} from 'lodash';

export default class MapStoreListModel extends ListModel {
    /**
     * @override
     */
    title = '';

    region = this.getConstant('ADDRESS');
    provinceDatasource = [{label: '省', value: ''}].concat(this.region.map(
        i => ({label: i.name, value: i.name})
    ));

    filter = assign(pick(this.filter, ['pageNo', 'pageSize']), {
        province: null,
        city: null,
        sortBy: '',
        title: ''
    });

    crumbData = [
        {
            text: '服务管理'
        },
        {text: '查看门店列表'}
    ];

    tableColumns = ['id', 'title', 'operations'];
    tableInfo = null;

    allColumnDatasource = [
        {label: '门店编号', value: 'id'},
        {label: '门店名称', value: 'title'},
        {label: '省', value: 'province'},
        {label: '市', value: 'city'},
        {label: '详细地址', value: 'address'},
        {label: '操作', value: 'operations'}
    ];
    customFields = [];

    serviceId = null;

    sync = false;

    tableSelectable = true;

    init() {
        super.init();

        this.listRequester = this.api.appServiceMapStoreList;
        this.tableInfoRequester = this.api.appServiceMapStoreTableInfo;
        this.deleteStoreRequester = this.api.appServiceMapStoreDelete;
        this.syncRequester = this.api.appServiceMapStoreSync;
        this.batchDeleteStoreRequester = this.api.appServiceMapStoreBatchDelete;

        this.serviceId = this.getRouteParams().serviceId;
    }

    prepareQuery(query) {
        query = super.prepareQuery(query);
        return {
            ...query,
            serviceId: this.serviceId
        };
    }

    async requestTableInfo() {
        this.tableInfo = await this.tableInfoRequester({serviceId: this.serviceId});
        this.sync = !!this.tableInfo.sync;
        this.customFields = filter(this.tableInfo.fields, ({identify, status}) => {
            return !includes(['mobile', 'img_url', 'lv_two_indus', 'lv_one_indus'], identify)
                && !status;
        });
        this.allColumnDatasource.push.apply(
            this.allColumnDatasource,
            this.customFields.map(i => ({value: i.identify, label: i.name}))
        );
    }

    requestDeleteStore(id) {
        return this.deleteStoreRequester({id, serviceId: this.serviceId});
    }

    requestBatchDeleteStore(ids) {
        return this.batchDeleteStoreRequester({
            ids: ids.join(','),
            serviceId: this.serviceId});
    }

    requestSync() {
        return this.syncRequester({serviceId: this.serviceId});
    }
}
